import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import z from "zod";

import { MarkdownRenderer } from "@/components/blog/markdown-renderer/markdown-renderer";
import { MarkdownRendererModes } from "@/components/blog/markdown-renderer/types";
import { useBlog } from "@/queries/strapi/blog.queries";
import { APP_ROUTES_FULL } from "@/utils/routes";

const BlogParamsSchema = z.object({
    id: z.string(),
});

export const Route = createFileRoute(APP_ROUTES_FULL.BLOG_DETAIL)({
    component: BlogEntry,
    params: {
        parse: (rawParams) => {
            const result = BlogParamsSchema.safeParse(rawParams);

            if (!result.success) {
                throw redirect({
                    to: APP_ROUTES_FULL.ROOT,
                    state: {
                        toast: {
                            type: "error",
                            message: "invalid_route_parameters",
                        },
                    },
                });
            }

            return result.data;
        },
        stringify: (params) => ({
            id: params.id,
        }),
    },
    staticData: {
        config: {
            title: "blog_detail",
        },
    },
});

function BlogEntry() {
    const { id } = Route.useParams();
    const { t } = useTranslation();

    const { data: post, isLoading, isError } = useBlog(id);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <p className="text-muted-foreground">{t("loading")}</p>
            </div>
        );
    }

    if (isError || !post) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <p className="text-muted-foreground">{t("blog_post_not_found")}</p>
            </div>
        );
    }

    return <MarkdownRenderer post={post} mode={MarkdownRendererModes.DETAIL} />;
}
